import { useEffect } from "react";
import { PAGE_VIEWED, DEFAULT_CURRENCY } from "config/trackingConsts";
import config from "config/config";
import { pagePath, pageUrl } from "utils/browserUtils";
import { initDataLayer } from "utils/trackingUtils";
import type { UseGTMProps } from "./useGTM.d";

const tagManagerArgs = {
  gtmId: config.gtmCode,
};

const getPageViewedData = (
  language: UseGTMProps["language"],
  pageType: UseGTMProps["pageType"],
  title: UseGTMProps["title"],
) => {
  const pageViewedData = {
    type: pageType,
    locale: language,
    link: pageUrl(),
    title,
    pagePath: pagePath(),
  };

  return pageViewedData;
};

const pushPageViewed = (pageViewedData: UseGTMProps) => {
  const { type: pageType, locale, title, link } = pageViewedData;

  window.dataLayer.push({
    userAgent: navigator.userAgent,
    pageUrl: link,
    pagePath: pagePath(),
    pageTitle: title,
    pageType,
    pageLanguage: locale,
    pageCurrency: DEFAULT_CURRENCY,
    event: PAGE_VIEWED,
    url: link,
  });
};

const initializeTracking = () => {
  import("react-gtm-module").then((TagManager) => {
    TagManager.initialize(tagManagerArgs);
  });
};

const trackPageViewed = (
  language: UseGTMProps["language"],
  pageType: UseGTMProps["pageType"],
) => {
  const { title } = document;
  initDataLayer();

  const pageViewedData = getPageViewedData(language, pageType, title);
  pushPageViewed(pageViewedData);
};

const useGTM = (
  language: UseGTMProps["language"],
  pageType: UseGTMProps["pageType"],
  isTrackingLess: UseGTMProps["isTrackingLess"]
) => {
  useEffect(() => {
    if (!isTrackingLess) {
      initializeTracking();
      trackPageViewed(language, pageType);
    }
  }, [language, pageType, isTrackingLess]);
};

export default useGTM;
